export default "__VITE_ASSET__5fd9d76b__"